import React from "react";
import { Group } from "react-konva";
import { mapPointToCanvas } from "../../trackTrace/mapUtils";
import { TrackTraceAsset, TrackTraceFloorMap } from "../../trackTrace/types";
import AssetMarker from "./AssetMarker";

interface Props {
    assets: TrackTraceAsset[];
    floorMap: TrackTraceFloorMap;
    canvasScale: number;
    selectedAssetId?: string | null;
    onSelectAsset: (asset: TrackTraceAsset) => void;
}

const AssetMarkerLayer: React.FC<Props> = ({ assets, floorMap, canvasScale, selectedAssetId, onSelectAsset }) => (
    <Group>
        {assets.map((asset) => {
            if (!asset.current_location) return null;
            const point = mapPointToCanvas(asset.current_location, floorMap);
            return (
                <AssetMarker
                    key={asset.id}
                    asset={asset}
                    x={point.x}
                    y={point.y}
                    canvasScale={canvasScale}
                    selected={selectedAssetId === asset.id}
                    onSelect={onSelectAsset}
                />
            );
        })}
    </Group>
);

export default AssetMarkerLayer;
